import React, { useState, useEffect, CSSProperties } from "react";

type CountdownTimerProps = {
  initialTime?: number;
  resetTrigger?: any;
  onComplete?: () => void;
  style?: CSSProperties;
  textStyle?: CSSProperties;
};

const CountdownTimer: React.FC<CountdownTimerProps> = (props) => {
  const initialTime = props.initialTime ?? 120;
  const [timeRemaining, setTimeRemaining] = useState(initialTime);

  // Reset timer เมื่อ resetTrigger เปลี่ยน
  useEffect(() => {
    setTimeRemaining(initialTime);
  }, [props.resetTrigger, initialTime]);

  // Countdown logic
  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerInterval);
          props.onComplete?.();
          return initialTime;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [initialTime, props.onComplete]);

  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = timeRemaining % 60;

  return (
    <div
      style={{
        backgroundColor: "rgba(118, 207, 227, 0.25)",
        borderRadius: ".28571429rem",
        ...props.style,
      }}
    >
      <div
        style={{
          color: "black",
          padding: "8px 20px",
          fontWeight: "bold",
          ...props.textStyle,
        }}
      >
        {`Refresh : ${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}
      </div>
    </div>
  );
};

export default CountdownTimer;
